export default "/images/vendor/flag-icons/flags/1x1/qa.svg?c64c7cc55e86f803cf1a1952a2d4ee78";